module.exports = __webpack_public_path__ + "img/jpan@2x.5b3585c0.png";